export const ENROLLMENTS_2_CONSTANTS = {
  ENROLLMENTS_FIELDS_CONFIG: [
    {
      fieldName: "headline_primary",
      label: "Headline (first line, dark)",
      value: "A full-stack AI engineering program",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "",
      required: false,
      defaultValue: "A full-stack AI engineering program",
      rows: 2,
    },
    {
      fieldName: "headline_accent",
      label: "Headline (accent line)",
      value: "to ship real-world AI systems",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "",
      required: false,
      defaultValue: "to ship real-world AI systems",
      rows: 2,
    },
    {
      fieldName: "body_paragraph_1",
      label: "Body paragraph 1",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "",
      required: false,
      defaultValue: "",
      rows: 4,
    },
    {
      fieldName: "body_paragraph_2",
      label: "Body paragraph 2",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "",
      required: false,
      defaultValue: "",
      rows: 4,
    },
    {
      fieldName: "body_paragraph_3",
      label: "Body paragraph 3",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "",
      required: false,
      defaultValue: "",
      rows: 4,
    },
    {
      fieldName: "stat_1_value",
      label: "Stat 1 — number",
      value: "160",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 160",
      required: false,
      defaultValue: "160",
    },
    {
      fieldName: "stat_1_label",
      label: "Stat 1 — caption",
      value: "Total Credits",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Total Credits",
      required: false,
      defaultValue: "Total Credits",
    },
    {
      fieldName: "stat_2_value",
      label: "Stat 2 — number",
      value: "1 – 8",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 1 – 8",
      required: false,
      defaultValue: "1 – 8",
    },
    {
      fieldName: "stat_2_label",
      label: "Stat 2 — caption",
      value: "Years to complete",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Years to complete",
      required: false,
      defaultValue: "Years to complete",
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
    {
      fieldName: "enable_lead_popup",
      label: "Enable lead popup",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "Show Apply CTA; opens the site lead popup (configure copy in Lead Popup, e.g. variant 7)",
      defaultValue: true,
    },
    {
      fieldName: "enable_lead_form",
      label: "Show the page's lead form inline (desktop)",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "On = the linked/global inline lead form (Page Settings, else the university default) fills the desktop slot. Mobile keeps the Apply Now button either way. Off = today's Apply CTA / embedded popup card.",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "bound_course_id",
      label: "Course for this programme (lead form)",
      value: "",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Optional — if set, course is fixed and read-only on apply",
      required: false,
      defaultValue: "",
      dynamicOptions: "courses",
    },
  ],
};
